import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { Box, Typography, Pressable } from '@/shared/design-system/primitives';
import { TextStyle, ViewStyle } from 'react-native';

interface MetabolicAIInputProps {
    value: string;
    onChange: (text: string) => void;
    onAnalyze: () => void;
    isAnalyzing: boolean;
}

/**
 * MetabolicAIInput: Conversational entry for AI decomposition.
 * 10000% VISUAL PARITY WITH COMMIT d7add58.
 */
export const MetabolicAIInput: React.FC<MetabolicAIInputProps> = ({ 
    value, onChange, onAnalyze, isAnalyzing 
}) => {
    
    // EXACT Transplants from d7add58
    const inputStyle: any = { 
        backgroundColor: 'rgba(255,255,255,0.02)', 
        borderWidth: 1,
        borderColor: '#222', 
        borderRadius: 8, 
        padding: 12, 
        color: '#fff', 
        fontSize: 13, 
        width: '100%',
        height: 60,
        fontWeight: '400',
        fontFamily: 'ui-sans-serif, system-ui, sans-serif'
    };

    return (
        <Box style={{ marginBottom: 20 }}>
            <textarea 
                placeholder="Describe additions... (e.g. '200g Greek Yogurt')"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{ ...inputStyle, resize: 'none' }}
            />
            
            <Pressable 
                onPress={onAnalyze}
                disabled={isAnalyzing || !value.trim()}
                style={{ 
                    width: '100%', 
                    paddingVertical: 12, 
                    marginTop: 10,
                    backgroundColor: isAnalyzing ? '#111' : 'rgba(6, 182, 212, 0.03)',
                    borderWidth: 1,
                    borderColor: isAnalyzing ? '#222' : 'rgba(6, 182, 212, 0.2)',
                    borderRadius: 10, 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    gap: 8
                }}
            >
                {isAnalyzing ? (
                    <Loader2 size={14} className="animate-spin" color="#06b6d4" />
                ) : (
                    <Sparkles size={12} color="#06b6d4" style={{ opacity: 0.6 }} />
                )}
                <Typography style={{ 
                    color: isAnalyzing ? '#444' : '#06b6d4',
                    fontSize: 11, 
                    fontWeight: '700', 
                    letterSpacing: 1,
                    textTransform: 'uppercase'
                }}>
                    {isAnalyzing ? 'DECOMPOSING...' : 'AI ESTIMATE'}
                </Typography>
            </Pressable>
        </Box>
    );
};
